const Theme = {
  card_background_color: '#47111C',

  header_full_height: true,
  logo_image_url: 'bellechasse.jpg',

  token_url: 'bellechasse.png',
  number_hidden: true,

  body_background_color: '#47111C',
  button_color: '#EF7C6F',
  button_half_border_color: '#47111C',

  text_font: 'PlusJakartaSans-Regular',
  text_color: 'white',

  title_font: 'MorningMemories',
  title_weight: 400,
  subtitle_font: 'PlusJakartaSans-Regular',

  popup_text_color: 'black',

  button_border_width: 1,
  button_radius: 10,
}

export default Theme
